// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__49h1f","field":"styles_field___wjsC","fieldCol":"styles_fieldCol__3KJq6","diffCol":"styles_diffCol__2vn62","diff":"styles_diff__2oxqw"};